import { useEffect, useState } from "react";
import Layout from "../../components/layout";
import { PortFolioBoxSection, PortFolioWrapperSection } from "./style";
import HeroSection from "./HeroSection";
import {
  ArrowForwardOrange,
  BlankImage
} from "../../shared/icons";
import { getTrendingNFTs } from "../../slices/dashboard/dashboardThunks";
import { AppDispatch } from "../../store";
import { useDispatch } from "react-redux";
import Loader from "../../components/shared-components/Loader";
import { IconButtonSmall } from "../../components/ButtonsNew";
import { useNavigate } from "react-router-dom";
import { getValidImageUrl } from "../../utils";

interface TrendingNFTs {
  id: string;
  image: string;
  nftType: string;
  nftName: string;
  price: number;
}

const Portfolio = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const [trendingNFTs, setTrendingNFTs] = useState<TrendingNFTs[] | null>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingMore, setIsLoadingMore] = useState<boolean>(false);

  useEffect(() => {
    getTrendingNFTsList();
  }, []);

  const getTrendingNFTsList = (
    limit: number = 5,
    pageNo: number = 1,
    isLoadingMore: boolean = false
  ) => {
    setIsLoading(!isLoadingMore);
    setIsLoadingMore(isLoadingMore);
    dispatch(getTrendingNFTs({ limit, page: pageNo }))
      .then((res: any) => {
        console.log("res nfts", res?.payload?.data);
        if (res?.error) {
          throw new Error(res?.payload);
        }
        setTotalPages(res?.payload?.data?.meta?.totalPages);
        setCurrentPage(res?.payload?.data?.meta?.currentPage);
        const mappedNFts = res?.payload?.data?.data?.map((item: any) => ({
          id: item?._id,
          image: item?.fileUrl,
          nftName: item?.name || "--",
          nftType: item?.nftType || "--",
          price: item?.price || "0.00",
        }));
        setTrendingNFTs(mappedNFts);
      })
      .catch((err) => {
        console.log({err});
      })
      .finally(() => {
        setIsLoading(false);
        setIsLoadingMore(false);
      });
  };
  return (
    <Layout fullScreen>
      <PortFolioWrapperSection>
        <HeroSection />
        <PortFolioBoxSection>
          {trendingNFTs?.length !== undefined && trendingNFTs?.length > 0 ? (
            <>
              <ul>
                <li>
                  {trendingNFTs?.map((item) => (
                    <div
                      className="main_content_box"
                      key={item?.id}
                      onClick={() => navigate(`/nft-details/${item?.id}`)}
                    >
                      <span>Digital Assets</span>
                      <img
                        src={
                          getValidImageUrl(item?.image ?? "" ,BlankImage)
                        }
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.src = BlankImage;
                        }}
                        alt="nft_img"
                      />
                      <div className="botom_content_box">
                        <h4>{item?.nftName}</h4>
                        <h5>{item?.price} ETH</h5>
                      </div>
                    </div>
                  ))}
                </li>
                <li>
                  {trendingNFTs?.map((item) => (
                    <div
                      key={item?.id}
                      onClick={() => navigate(`/nft-details/${item?.id}`)}
                    >
                      <div className="main_content_box">
                        <span>Digital Assets</span>
                        <img
                          src={
                            getValidImageUrl(item?.image ?? "" ,BlankImage)

                          }
                          onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.src = BlankImage;
                          }}
                          alt="nft_img"
                        />
                        <div className="botom_content_box">
                          <h4>{item?.nftName}</h4>
                          <h5>{item?.price} ETH</h5>
                        </div>
                      </div>
                    </div>
                  ))}
                </li>
              </ul>
              <div style={{ textAlign: "center" }}>
                <IconButtonSmall
                  icon={<ArrowForwardOrange />}
                  onClick={() => navigate("/marketplace")}
                >
                  View all Collections
                </IconButtonSmall>
              </div>
            </>
          ) : (
            <Loader />
          )}
        </PortFolioBoxSection>
      </PortFolioWrapperSection>
    </Layout>
  );
};

export default Portfolio;
